import firebase from 'firebase/app';
import 'firebase/firestore';
import firebaseKeys from '@/utilities/firebaseKeys';

const config = firebaseKeys[process.env.NODE_ENV];
const db = firebase
  .initializeApp(config)
  .firestore();

const dbCollection = ({
  model,
  where,
  orderBy,
  limit,
  group,
  orderByChild,
  startAt,
  endAt,
}) => {
  let collection = group ? db.collectionGroup(model) : db.collection(model);
  if (orderBy) {
    orderBy.forEach(({ prop, direction }) => {
      collection = collection.orderBy(prop, direction);
    });
  }
  if (limit) {
    collection = collection.limit(limit);
  }
  if (where) {
    where.forEach(({ prop, comparison, value }) => {
      collection = collection.where(prop, comparison, value);
    });
  }
  if (orderByChild) {
    collection = collection.orderByChild(orderByChild);
  }
  if (startAt) {
    collection = collection.startAt(startAt);
  }
  if (endAt) {
    collection = collection.endAt(endAt);
  }
  return collection;
};

const getArray = (response) => {
  const data = [];
  response.forEach(record => data.push({ id: record.id, ...record.data() }));
  return data;
};

const getCollection = params => dbCollection(params).get().then(response => getArray(response));

const getRecord = ({ id, ...params }) => dbCollection(params).doc(id).get()
  .then(response => response.data());

const createRecord = ({ model, value }) => dbCollection({ model }).add(value);

const updateRecord = ({ id, value, ...params }) => dbCollection(params).doc(id).update(value);

const setRecord = ({ id, value, ...params }) => dbCollection(params).doc(id).set(value);

const deleteRecord = ({ model, id }) => dbCollection({ model }).doc(id).delete();

const addToArray = firebase.firestore.FieldValue.arrayUnion;

const removeFromArray = firebase.firestore.FieldValue.arrayRemove;

const increment = firebase.firestore.FieldValue.increment(1);

const getDBTime = () => firebase.firestore.Timestamp.now();

const getTimestamp = dateString => firebase.firestore.Timestamp.fromDate(dateString);

export {
  db,
  getDBTime,
  getTimestamp,
  dbCollection,
  getArray,
  getCollection,
  getRecord,
  updateRecord,
  createRecord,
  setRecord,
  deleteRecord,
  addToArray,
  removeFromArray,
  increment,
};
